import React from 'react';
import { Row, Col } from 'antd';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { profilesSelector } from 'redux/reducers/profiles';
import { profileTypesSelector } from 'redux/reducers/profileTypes';
import ProfileCard from './ProfileCard/ProfileCard';
import AddProfileButton from './AddProfileButton/AddProfileButton';
import ProfileCardSkeleton from './ProfileCardSkeleton/ProfileCardSkeleton';
import './styles.less';

const CardGrid = ({ onNewProfileClick, onEditProfileClick, loading }) => {
  const profiles = useSelector(profilesSelector);
  const profileTypes = useSelector(profileTypesSelector);

  const usedProfileTypeListIds = profiles.map((profile) => profile.profileTypeId);

  const isNewProfileTypeAvailable = profileTypes.some(
    (profileType) =>
      profileType.multiConfigAllowed === true ||
      !usedProfileTypeListIds.includes(profileType.profileTypeId),
  );

  if (loading) {
    const skeletons = [
      <ProfileCardSkeleton key="1" />,
      <ProfileCardSkeleton key="2" />,
      <ProfileCardSkeleton key="3" />,
    ];

    return (
      <div className="card-grid__container">
        <Row
          type="flex"
          justify="start"
          align="middle"
          gutter={[
            { xs: 16, sm: 16, md: 16, lg: 16 },
            { xs: 16, sm: 16, md: 16, lg: 16 },
          ]}
        >
          {skeletons.map((item) => (
            <Col
              key={item.key}
              className="card-grid__col"
              xs={24}
              sm={12}
              md={8}
              lg={8}
              xl={6}
              xxl={4}
            >
              {item}
            </Col>
          ))}
        </Row>
      </div>
    );
  }
  return (
    <div className="card-grid__container">
      <Row
        type="flex"
        justify="start"
        align="middle"
        gutter={[
          { xs: 16, sm: 16, md: 24, lg: 32 },
          { xs: 16, sm: 16, md: 24, lg: 32 },
        ]}
      >
        {profiles.map((profile) => (
          <Col
            key={profile.profileId}
            className="card-grid__col"
            xs={24}
            sm={12}
            md={8}
            lg={8}
            xl={6}
            xxl={4}
          >
            <ProfileCard profile={profile} onEdit={onEditProfileClick} />
          </Col>
        ))}
        {isNewProfileTypeAvailable && (
          <Col
            key="create_profile_card"
            className="card-grid__col"
            xs={24}
            sm={12}
            md={8}
            lg={8}
            xl={6}
            xxl={4}
          >
            <AddProfileButton onClick={onNewProfileClick} />
          </Col>
        )}
      </Row>
    </div>
  );
};

CardGrid.propTypes = {
  onNewProfileClick: PropTypes.func.isRequired,
  onEditProfileClick: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

CardGrid.defaultProps = {
  loading: false,
};

export default CardGrid;
